export const ANTHROPIC_OAUTH_POPUP_MESSAGE =
	"clerical:anthropic-subscription-oauth";
const ANTHROPIC_OAUTH_CHANNEL_PREFIX = `${ANTHROPIC_OAUTH_POPUP_MESSAGE}:`;

export function anthropicOAuthChannelName(state: string): string {
	return `${ANTHROPIC_OAUTH_CHANNEL_PREFIX}${state}`;
}

export type AnthropicOAuthCallback = { code: string; state: string };

export function parseAnthropicOAuthCallback(
	value: string,
	expectedRedirectUri: string,
	expectedState: string,
): AnthropicOAuthCallback {
	let callback: URL;
	let expected: URL;
	try {
		callback = new URL(value.trim());
		expected = new URL(expectedRedirectUri);
	} catch {
		throw new Error("subscription.oauth.callback_invalid");
	}
	if (
		callback.protocol !== expected.protocol ||
		callback.hostname !== expected.hostname ||
		callback.port !== expected.port ||
		callback.pathname !== expected.pathname ||
		callback.username !== expected.username ||
		callback.password !== expected.password
	) {
		throw new Error("subscription.oauth.callback_redirect_mismatch");
	}
	if (callback.searchParams.has("error")) {
		throw new Error("subscription.oauth.provider_denied");
	}
	const code = callback.searchParams.get("code")?.trim();
	const state = callback.searchParams.get("state")?.trim();
	if (!code || !state) {
		throw new Error("subscription.oauth.callback_invalid");
	}
	if (state !== expectedState) {
		throw new Error("subscription.oauth.state_mismatch");
	}
	return { code, state };
}

export type AnthropicOAuthPopupResult =
	| { type: typeof ANTHROPIC_OAUTH_POPUP_MESSAGE; status: "connected" }
	| {
			type: typeof ANTHROPIC_OAUTH_POPUP_MESSAGE;
			status: "error";
			code: string;
	  };

export function publishAnthropicOAuthResult(
	result: AnthropicOAuthPopupResult,
	state: string,
): void {
	if (typeof BroadcastChannel !== "undefined") {
		const channel = new BroadcastChannel(anthropicOAuthChannelName(state));
		channel.postMessage(result);
		channel.close();
	}
	window.opener?.postMessage(result, window.location.origin);
	window.close();
}
